import AppCard from '@crema/core/AppCard';
import AppList from '@crema/core/AppList';
import AppScrollbar from '@crema/core/AppScrollbar';
import jwtAxios from '@crema/services/auth/jwt-auth';
import {useAuthUser} from '@crema/utility/AuthHooks';
import {ArrowBack, FilterFrames, History, Info} from '@mui/icons-material';
import AppConfirmDialog from '@crema/core/AppConfirmDialog';
import PropTypes from 'prop-types';
import {
  Box,
  Breadcrumbs,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import {grey, red} from '@mui/material/colors';
import moment from 'moment';
import {useCallback, useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {
  onAddAttachmentDigisign,
  onAddAttachmentDigisignSK,
  onAddDocumentDigisign,
  onChangeFilter,
  onDeleteAttachmentDigisign,
  onGetDetailDraftDigisign,
  onGetDokumenSKPYB,
  onGetDokumenSKPYBPPID,
  onPutDocumentDigisign,
} from 'redux/actions/DigitalSign';
import AddressBookItem from 'shared/components/Addressbook/AddressBookItem';
import AddressBookWrapper from 'shared/components/Addressbook/AddressBookWrapper';
import Addressbook from 'shared/components/Addressbook/Addressbook';
import {ButtonContained, ButtonOutlined} from 'shared/components/Button';
import {FETCH_ERROR} from 'shared/constants/ActionTypes';
import {COLORS} from 'shared/constants/AppEnums';
import useModal from 'shared/hooks/useModal';
import FileRow from './FileRow';
import PetunjukDialog from './PetunjukDialog';
import UploadModern from './UploadModern';
import LogHistory from '../../Components/LogHistory';
import AppInfoView from '@crema/core/AppInfoView';
import {PDFDocument, PDFName} from 'pdf-lib';

const optionJenisSk = [
  {
    category: 'SK MUTASI',
    value: 'SK Penempatan',
    label: 'SK Penempatan (pindah antar instansi)',
  },
  {
    category: 'SK MUTASI',
    value: 'SK Pindah Antar Unit Kerja',
    label: 'SK Pindah Antar Unit Kerja',
  },
  {
    category: 'SK MUTASI',
    value: 'SK Pemindahan Jabatan',
    label: 'SK Pemindahan Jabatan',
  },
  {
    category: 'SK MUTASI',
    value: 'SK Cuti Diluar Tanggungan Negara',
    label: 'SK Cuti Diluar Tanggungan Negara',
  },
  {
    category: 'SK MUTASI',
    value: 'SK Pengaktifan Cuti Diluar Tanggungan Negara',
    label: 'SK Pengaktifan Cuti Diluar Tanggungan Negara',
  },
  {category: 'SK MUTASI', value: 'SK Penugasan', label: 'SK Penugasan'},
  {
    category: 'SK JF',
    value: 'SK Pengangkatan Pertama JFT',
    label: 'SK Pengangkatan Pertama dalam Jabatan Fungsional Tertentu',
  },
  {
    category: 'SK JF',
    value: 'SK Pengangkatan Perpindahan JFT',
    label: 'SK Pengangkatan Perpindahan JFT',
  },
  {
    category: 'SK JF',
    value: 'SK Kenaikan Jabatan FT',
    label: 'SK Kenaikan Jabatan FT',
  },
  {
    category: 'SK JF',
    value: 'SK Pemberhentian JFT',
    label: 'SK Pemberhentian JFT',
  },
  {
    category: 'SK JF',
    value: 'SK Pengangkatan Kembali JFT',
    label: 'SK Pengangkatan Kembali JFT',
  },
  {
    category: 'SK PEMBERHENTIAN',
    value: 'SK Pemberhentian Tanpa Hak Pensiun',
    label:
      'SK Pemberhentian dengan hormat atas permintaan sendiri tanpa hak pensiun',
  },
  {
    category: 'SK PEMBERHENTIAN',
    value: 'SK Pemberhentian Meninggal Dunia',
    label: 'SK Pemberhentian karena meninggal dunia (punah)',
  },
  {
    category: 'SK PEMBERHENTIAN',
    value: 'SK Pensiun Anumerta',
    label: 'SK Pensiun Anumerta',
  },
  {
    category: 'SK PEMBERHENTIAN',
    value: 'SK Masa Persiapan Pensiun',
    label: 'SK Masa Persiapan Pensiun',
  },
  {
    category: 'SK PPPK',
    value: 'SK Pengangkatan Calon PPPK',
    label: 'SK Pengangkatan Calon PPPK',
  },
  {
    category: 'SK PPPK',
    value: 'SK Pengangkatan PPPK',
    label: 'SK Pengangkatan PPPK',
  },
  {
    category: 'SK PPPK',
    value: 'SK Perpanjangan PPPK',
    label: 'SK Perpanjangan PPPK',
  },
  {
    category: 'SK PPPK',
    value: 'SK KGB PPPK',
    label: 'SK KGB PPPK',
  },
  {
    category: 'SK DISIPLIN',
    value: 'SK Disiplin',
    label: 'SK Disiplin',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Tugas Belajar Dibiayai Dalam Negeri',
    label: 'SK Tugas Belajar Dibiayai Dalam Negeri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Tugas Belajar Dibiayai Luar Negeri',
    label: 'SK Tugas Belajar Dibiayai Luar Negeri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Tugas Belajar Mandiri',
    label: 'SK Tugas Belajar Mandiri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Perpanjangan Tugas Belajar Dibiayai Dalam Negeri',
    label: 'SK Perpanjangan Tugas Belajar Dibiayai Dalam Negeri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Perpanjangan Tugas Belajar Dibiayai Luar Negeri',
    label: 'SK Perpanjangan Tugas Belajar Dibiayai Luar Negeri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Perpanjangan Tugas Belajar Mandiri',
    label: 'SK Perpanjangan Tugas Belajar Mandiri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Aktif Bekerja Kembali Tugas Belajar Dibiayai Dalam Negeri',
    label: 'SK Aktif Bekerja Kembali Tugas Belajar Dibiayai Dalam Negeri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Aktif Bekerja Kembali Tugas Belajar Dibiayai Luar Negeri',
    label: 'SK Aktif Bekerja Kembali Tugas Belajar Dibiayai Luar Negeri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value:
      'SK Aktif Bekerja Kembali Sementara Tugas Belajar Dibiayai Dalam Negeri',
    label:
      'SK Aktif Bekerja Kembali Sementara Tugas Belajar Dibiayai Dalam Negeri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value:
      'SK Aktif Bekerja Kembali Sementara Tugas Belajar Dibiayai Luar Negeri',
    label:
      'SK Aktif Bekerja Kembali Sementara Tugas Belajar Dibiayai Luar Negeri',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Penggantian Tugas Belajar',
    label: 'SK Penggantian Tugas Belajar',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Perubahan Tugas Belajar',
    label: 'SK Perubahan Tugas Belajar',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Pemberhentian Tugas Belajar',
    label: 'SK Pemberhentian Tugas Belajar',
  },
  {
    category: 'SK TUGAS BELAJAR',
    value: 'SK Pembatalan Tugas Belajar',
    label: 'SK Pembatalan Tugas Belajar',
  },
];

const TambahDokumen = (props) => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const {user} = useAuthUser();
  const navigation = useNavigate();
  const {pathname} = useLocation();
  const {type: tipeDokumen} = useParams();

  const {optionPYB, optionPYBPPID} = useSelector((s) => s.digiSign);
  const {attachment, detail} = useSelector((state) => state.digiSign);

  const [index, setIndex] = useState(-1);
  const [modalConfSave, setModalConfSave] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [modalConfSubmit, setModalConfSubmit] = useState(false);
  const [isUploadDokumen, setIsUploadDokumen] = useState(false);
  const [filteredJenisSkOption, setFilteredJenisSkOption] = useState([
    optionJenisSk,
  ]);
  const [dataDokumen, setDataDokumen] = useState({
    judul: '',
    noSertif: '',
    jenis: '',
    jenisSk: '',
    tglSurat: moment().format('YYYY-MM-DD'),
    penanda: '',
    displayApproval: [],
    pilihanApproval: [],
    penerimaCode: [],
    ppidCode: [],
    displayPenerima: [],
    pilihanPenerima: [],
    displayPPID: [],
    pilihanPPID: [],
    tembusanCode: [],
    displayTembusan: [],
    pilihanTembusan: [],
    keterangan: '',
    formError: {
      judul: '',
      errorJudul: false,
      noSertif: '',
      tglSurat: new Date(),
      errorTglSurat: false,
      errorNoSertif: false,
      jenis: '',
      errorJenis: false,
      penanda: '',
      errorPenanda: false,
      penerima: '',
      errorPenerima: false,
      errorTembusan: false,

      attachment: '',
      errorAttachment: false,
      keterangan: '',
      errorKeterangan: false,
      approval: '',
      errorApproval: false,
    },
  });
  const [countUploadDokumen, setCountUploadDokumen] = useState(0);

  const [openAddressbook, setOpenAddressbook] = useState({
    id: '',
    toggle: false,
  });
  const [pilihanPenanda, setpilihanPenanda] = useState([]);
  const [openPetunjuk, setOpenPetunjuk] = useState(false);

  // const { loading } = useSelector(state => state.common)
  const [config, setConfig] = useState({});
  const {stateAddress, toggleShow, toggleHide, setPayloadOnHide} = useModal();

  const onDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      setIsUploadDokumen(false);
      if (fileRejections.length !== 0 && acceptedFiles.length === 0) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Tipe File Tidak Mendukung',
        });
      } else {
        setUploadedFiles(null);
        setCountUploadDokumen(0);
        dispatch(onDeleteAttachmentDigisign());
        const size = (acceptedFiles[0].size / 1024 / 1024).toFixed(3);
        if (size <= 50) {
          let tipe = 'SK';
          if (tipeDokumen === 'ppid') tipe = 'PPID';
          if (tipeDokumen === 'dirjend') tipe = 'DIRJEND';

          dispatch(onAddAttachmentDigisignSK(tipe, acceptedFiles[0]));
          setUploadedFiles({
            name: setDocumentTypeFile(tipeDokumen) + acceptedFiles[0].name,
            type: acceptedFiles[0].type,
            size: acceptedFiles[0].size,
            file: URL.createObjectURL(acceptedFiles[0]),
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: 'Ukuran File Maksimal 50 MB',
          });
        }
      }
    },
    [tipeDokumen],
  );

  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'application/': ['.pdf'],
    },
  });

  const onDeleteUploadFile = (file) => {
    // const data = uploadedFiles
    // const index = data.indexOf(file)
    // data.splice(index, 1)
    setUploadedFiles(null);
    setCountUploadDokumen(0);

    // const dataResponseAttachment = documentAttachment
    // const dataDeleted = dataResponseAttachment.at(index)

    // dataResponseAttachment.splice(index, 1)
    dispatch(onDeleteAttachmentDigisign());
  };

  const onDeleteAddressBook = (item, title) => {
    const mappings = {
      Penerima: {
        displayKey: 'displayPenerima',
        pilihanKey: 'pilihanPenerima',
        codeKey: 'penerimaCode',
      },
      // Add other title mappings here
      Tembusan: {
        displayKey: 'displayTembusan',
        pilihanKey: 'pilihanTembusan',
        codeKey: 'tembusanCode',
      },
      Penanda: {
        displayKey: 'displayPPID',
        pilihanKey: 'pilihanPPID',
        codeKey: 'ppidCode',
      },
      // Continue for other titles
    };

    const mapping = mappings[title];
    if (!mapping) {
      console.error(`Unhandled title: ${title}`);
      return;
    }

    const dataDisplay = [...dataDokumen[mapping.displayKey]];
    const dataPilihan = [...dataDokumen[mapping.pilihanKey]];
    const dataCode = [...dataDokumen[mapping.codeKey]];
    const dataNip = mapping.nipKey ? [...dataDokumen[mapping.nipKey]] : null;

    const index = dataDisplay.indexOf(item);
    if (index > -1) {
      dataDisplay.splice(index, 1);
      dataPilihan.splice(index, 1);
      dataCode.splice(index, 1);
      if (dataNip) dataNip.splice(index, 1);
    }

    setDataDokumen({
      ...dataDokumen,
      [mapping.displayKey]: dataDisplay,
      [mapping.pilihanKey]: dataPilihan,
      [mapping.codeKey]: dataCode,
      ...(dataNip && {[mapping.nipKey]: dataNip}),
    });
  };

  const handleInputDocument = (name, value) => {
    if (name === 'jenis' && value === 'SK DISIPLIN') {
      const selectedCategory = value;
      const filtered = optionJenisSk.filter(
        (option) =>
          option.category === selectedCategory || selectedCategory === '',
      );
      setDataDokumen({
        ...dataDokumen,
        [name]: value,
        jenisSk: filtered[0].value,
      });
    } else if (name === 'jenis' || name === 'jenisSk') {
      setDataDokumen({
        ...dataDokumen,
        [name]: value,
        penanda: '',
        displayApproval: [],
        pilihanApproval: [],
      });
    } else {
      setDataDokumen({
        ...dataDokumen,
        [name]: value,
      });
    }
  };

  const handleValidationInput = () => {
    let judul = '';
    let errorJudul = false;
    let noSertif = '';
    let errorNoSertif = false;
    let jenis = '';
    let errorJenis = false;
    let penanda = '';
    let errorPenanda = false;
    let lampiran = '';
    let errorLampiran = false;
    let keterangan = '';
    let errorKeterangan = false;
    let penerima = '';
    let errorPenerima = false;

    if (dataDokumen.judul === '') {
      judul = 'Judul Wajib diisi';
      errorJudul = true;
    } else {
      judul = '';
      errorJudul = false;
    }

    if (dataDokumen.noSertif === '') {
      noSertif = 'No Sertif Wajib diisi';
      errorNoSertif = true;
    } else {
      noSertif = '';
      errorNoSertif = false;
    }

    if (dataDokumen.jenis === '') {
      jenis = 'Jenis Dokumen Wajib diisi';
      errorJenis = true;
    } else {
      jenis = '';
      errorJenis = false;
    }

    if (
      (dataDokumen.penanda === '' && tipeDokumen === 'sdmao') ||
      (dataDokumen.ppidCode.length === 0 &&
        (tipeDokumen === 'ppid' || tipeDokumen === 'dirjend'))
    ) {
      errorPenanda = true;
      penanda = 'Penandatangan Dokumen Wajib Diisi';
    } else {
      errorPenanda = false;
      penanda = '';
    }

    if (attachment.length === 0 || countUploadDokumen === 0) {
      errorLampiran = true;
      lampiran = 'Harap upload Dokumen Terlebih Dahulu';
    } else {
      errorLampiran = false;
      lampiran = '';
    }

    // if (dataDokumen.keterangan === '') {
    //     keterangan = 'Keterangan Wajib diisi'
    //     errorKeterangan = true
    // } else {
    //     keterangan = ''
    //     errorKeterangan = false
    // }

    if (dataDokumen.penerimaCode.length === 0) {
      errorPenerima = true;
      penerima = 'Penerima Wajib Dipilih';
    } else {
      errorPenerima = false;
      penerima = '';
    }

    setDataDokumen({
      ...dataDokumen,
      formError: {
        judul: judul,
        errorJudul: errorJudul,
        noSertif: noSertif,
        errorNoSertif: errorNoSertif,
        jenis: jenis,
        errorJenis: errorJenis,
        penanda: penanda,
        errorPenanda: errorPenanda,
        attachment: lampiran,
        errorAttachment: errorLampiran,
        keterangan: keterangan,
        errorKeterangan: errorKeterangan,
        penerima: penerima,
        errorPenerima: errorPenerima,
      },
    });
  };

  const handleSubmitDokumen = (action) => {
    if (
      dataDokumen.judul === '' ||
      dataDokumen.noSertif === '' ||
      (dataDokumen.jenis === '' && tipeDokumen === 'sdmao') ||
      (dataDokumen.jenisSk === '' && tipeDokumen === 'sdmao') ||
      (dataDokumen.penanda === '' && tipeDokumen === 'sdmao') ||
      (dataDokumen.ppidCode.length === 0 &&
        (tipeDokumen === 'ppid' || tipeDokumen === 'dirjend')) ||
      dataDokumen.penerimaCode.length === 0 ||
      attachment.length === 0 ||
      countUploadDokumen === 0
    ) {
      handleValidationInput();
      dispatch({
        type: FETCH_ERROR,
        payload: 'Mohon Masukan Data Dokumen Dengan Benar',
      });
    } else {
      const checkLabel = checkLabelExist();

      let arrApproval = dataDokumen.displayApproval.map((x) => {
        return x.origin.nik;
      });
      arrApproval.push(dataDokumen.penanda);

      if (!checkLabel) {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Mohon Masukan Label',
        });
      } else {
        const data = {
          subject: dataDokumen.judul,
          approvers:
            tipeDokumen === 'sdmao' ? arrApproval : dataDokumen.ppidCode,
          tembusans: dataDokumen.tembusanCode,
          receivers: dataDokumen.penerimaCode,
          id_attachments: [],
          action: action,
          tipe_dokumen: setDocumentType(tipeDokumen),
          extra_attributes: {
            noDokumen: dataDokumen.noSertif,
            keterangan: dataDokumen.keterangan,
            tanggalDokumen: new Date(dataDokumen.tglSurat).toISOString(),
            jenisDokumen: dataDokumen.jenisSk,
            tipeDokumen: dataDokumen.jenis,
          },
          comment: 'comment',
          app: 'Dokumen SK',
          base_url: `/apps/dokumen-sk/detail/${tipeDokumen}/$id?filter=sk-need-approval`,
          message: 'Dokumen perlu disetujui',
        };

        attachment.map((item) => {
          data.id_attachments.push(item.id);
        });

        if (id !== undefined) {
          dispatch(
            onPutDocumentDigisign(data, id, () =>
              handleNavigation(`/apps/dokumen-sk`),
            ),
          );
          if (action === 'submit') {
            dispatch(onChangeFilter('composer'));
          } else if (action === 'draft') {
            dispatch(onChangeFilter('draft'));
          }
        } else {
          dispatch(
            onAddDocumentDigisign(data, setDocumentType(tipeDokumen), () =>
              handleNavigation(`/apps/dokumen-sk`),
            ),
          );
          if (action === 'submit') {
            dispatch(onChangeFilter('composer'));
          } else {
            dispatch(onChangeFilter('draft'));
          }
        }
      }
    }
  };

  const handleCancelDocument = () => {
    handleNavigation(-1);
    handleResetDocument();
  };

  const handleResetDocument = () => {
    setDataDokumen({
      judul: '',
      noSertif: '',
      jenis: '',
      penandaCode: [],
      displayPenanda: [],
      displayApproval: [],
      pilihanPenanda: [],
      penandaNip: [],
      ppidCode: [],
      displayPPID: [],
      pilihanPPID: [],
      tglSurat: moment().format('YYYY-MM-DD'),
      keterangan: '',
      displayTembusan: [],
      displayPenerima: [],
      penerimaCode: [],
      pilihanPenerima: [],
      formError: {
        judul: '',
        errorJudul: false,
        noSertif: '',
        errorNoSertif: false,
        jenis: '',
        errorJenis: false,
        penanda: '',
        errorPenanda: false,
        attachment: '',
        errorAttachment: false,
        keterangan: '',
        errorKeterangan: false,
        penerima: '',
        errorPenerima: false,
      },
    });
    setUploadedFiles(null);
    setIsUploadDokumen(false);
    setCountUploadDokumen(0);
    dispatch(onDeleteAttachmentDigisign());
  };

  const getDefaultPPID = () => {
    dispatch(onGetDokumenSKPYBPPID());
  };

  const handleToggleAddressBook = (title) => {
    let payloadPilihan;
    if (title === 'Penerima') {
      payloadPilihan = dataDokumen.pilihanPenerima
        ? [...dataDokumen.pilihanPenerima]
        : [];
    } else if (title === 'Tembusan')
      payloadPilihan = dataDokumen.pilihanTembusan
        ? [...dataDokumen.pilihanTembusan]
        : [];
    else if (title === 'Penanda')
      payloadPilihan = dataDokumen.pilihanPPID
        ? [...dataDokumen.pilihanPPID]
        : [];

    setConfig((config) => ({
      ...config,
      judul: title,
      tabs: {
        jabatan: title === 'Penerima' ? false : true,
        pegawai: true,
        personal: false,
        klasifikasi: false,
      },
      multiselect: true,
      payloadPilihan: payloadPilihan,
    }));
    toggleShow();
  };

  const handleNavigation = (to) => {
    handleResetDocument();
    navigation(to);
  };

  const handleCountUploadDokumen = () => {
    setCountUploadDokumen((prev) => prev + 1);
  };

  const handleUploadDokumen = async () => {
    const checkLabel = checkLabelExist();
    if (checkLabel) {
      setIsUploadDokumen(true);

      try {
        const iframe = document.querySelector('iframe');
        const datapdf =
          await iframe?.contentWindow?.PDFViewerApplication?.getPDFBlob();

        if (!datapdf) throw new Error('Gagal mengambil PDF');

        // 1. Ambil data ArrayBuffer dengan aman
        let arrayBuffer;
        if (datapdf instanceof Uint8Array) {
          arrayBuffer = datapdf.buffer;
        } else if (datapdf instanceof ArrayBuffer) {
          arrayBuffer = datapdf;
        } else if (datapdf instanceof Blob) {
          arrayBuffer = await datapdf.arrayBuffer();
        } else {
          arrayBuffer = await new Response(datapdf).arrayBuffer();
        }

        const pdfDoc = await PDFDocument.load(arrayBuffer);

        // 2. Kunci form field biasa
        pdfDoc.getForm().flatten();

        // 3. KUNCI MUTLAK SEMUA ANOTASI (Tanpa perlu import PDFDict)
        const pages = pdfDoc.getPages();
        pages.forEach((page) => {
          const annots = page.node.Annots();

          if (annots) {
            for (let i = 0; i < annots.size(); i++) {
              // Ambil referensi anotasi
              const annotRef = annots.get(i);
              // Cari objek aslinya di dalam struktur PDF
              const annot = pdfDoc.context.lookup(annotRef);

              if (annot) {
                // Paksa berikan Flag 708 (ReadOnly + Locked + LockedContents + Print)
                annot.set(PDFName.of('F'), pdfDoc.context.obj(708));

                // Hapus metadata editor bawaan agar tidak memunculkan popup/tools
                annot.delete(PDFName.of('Popup'));
                annot.delete(PDFName.of('IRT'));
              }
            }
          }
        });

        // 4. Save tanpa menyertakan metadata editor
        const pdfBytes = await pdfDoc.save({useObjectStreams: false});

        const finalBlob = new Blob([pdfBytes], {type: 'application/pdf'});
        var file = new File([finalBlob], uploadedFiles.name, {
          type: uploadedFiles.type,
          path: uploadedFiles.name,
        });

        let tipe = 'SK';
        if (tipeDokumen === 'ppid') tipe = 'PPID';
        if (tipeDokumen === 'dirjend') tipe = 'DIRJEND';

        dispatch(
          onAddAttachmentDigisignSK(tipe, file, handleCountUploadDokumen),
        );
      } catch (error) {
        console.error('Gagal memproses flattening PDF:', error);
      }
    } else {
      dispatch({
        type: FETCH_ERROR,
        payload: 'Mohon Masukan Label',
      });
    }
  };

  const checkLabelExist = () => {
    const iframe = document.querySelector('iframe');
    return iframe?.contentWindow?.PDFViewerApplication._hasAnnotationEditors;
  };

  const getLabelSign = (url) => {
    jwtAxios
      .get(url, {responseType: 'blob'})
      .then((data) => {
        window.sign_file_blob = data.data;
      })
      .catch((error) => {
        console.debug('error ', error);
      });
  };

  const openPDF = (data) => {
    const iframe = document.querySelector('#iframeDokLain');
    const wrapper = document.querySelector('#wrapperIframe');
    if (iframe) {
      wrapper.appendChild(iframe);

      iframe.onload = function () {
        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow.document;

        // Inject custom styles into the iframe
        const style = iframeDoc.createElement('style');
        style.textContent = `
                    #editorModeButtons #editorFreeText,
                    #editorModeButtons #editorInk {
                        display: none !important; /* Hide specific annotations */
                    }
                `;
        iframeDoc.head.appendChild(style);

        // Open the PDF file in the viewer
        iframe.contentWindow?.PDFViewerApplication.open(data);
      };
    }
  };

  const setDocumentType = (input) => {
    switch (input) {
      case 'sdmao':
        return 'dokumen_sk';
      case 'ppid':
        return 'dokumen_ppid';
      case 'dirjend':
        return 'dokumen_dirjend';
      default:
        return 'dokumen_sk';
    }
  };

  const setDocumentTypeFile = (input) => {
    switch (input) {
      case 'sdmao':
        return 'SK_';
      case 'ppid':
        return 'PPID_';
      case 'dirjend':
        return 'DIRJEND_';
      default:
        return 'SK_';
    }
  };

  const handleOnChangePenanda = (name, value) => {
    let idx = pilihanPenanda.findIndex((x) => x.origin.nik === value);

    if (idx > -1) {
      let arr = [];
      // TODO: Data katimjaHumanCapital masih hardcode, jika pemangku jabatan rubah maka sesuaikan data dengan get dari API seperti yang sudah ada.
      let katimjaHumanCapital = {
        name: 'KETUA TIM KERJA HUMAN CAPITAL',
        origin: {
          nik: '198607262009122001',
          name: 'AYUDHIA PARAMESTI',
        },
      };
      let katimjaBudayaKerja = {
        name: 'KETUA TIM KERJA BUDAYA KERJA DAN PEMBINAAN ETIKA PEGAWAI',
        origin: {
          nik: '198202022009011012',
          name: 'HIMAWAN DANANG MURWINANTO',
        },
      };
      switch (idx) {
        case 0:
          if (
            dataDokumen.jenisSk === 'SK Kenaikan Jabatan FT' ||
            dataDokumen.jenis === 'SK PEMBERHENTIAN' ||
            dataDokumen.jenis === 'SK MUTASI'
          ) {
            arr.push(optionPYB[4]);
          } else if (
            dataDokumen.jenis === 'SK TUGAS BELAJAR' ||
            dataDokumen.jenisSk === 'SK Pengangkatan Calon PPPK' ||
            dataDokumen.jenisSk === 'SK Pengangkatan PPPK'
          ) {
            arr.push(katimjaHumanCapital);
          } else if (dataDokumen.jenisSk === 'SK Disiplin') {
            arr.push(katimjaBudayaKerja);
          } else if (dataDokumen.jenis !== 'SK TUGAS BELAJAR') {
            arr.push(optionPYB[5]);
          }
          arr.push(optionPYB[3]);
          arr.push(optionPYB[2]);
          arr.push(optionPYB[1]);

          setDataDokumen({
            ...dataDokumen,
            displayApproval: arr,
            penanda: value,
          });
          break;

        case 1:
          arr = [];

          if (
            dataDokumen.jenisSk === 'SK Kenaikan Jabatan FT' ||
            dataDokumen.jenis === 'SK PEMBERHENTIAN' ||
            dataDokumen.jenis === 'SK MUTASI'
          ) {
            arr.push(optionPYB[4]);
          } else if (
            dataDokumen.jenis === 'SK PPPK' &&
            dataDokumen.jenisSk !== 'SK Pengangkatan Calon PPPK' &&
            dataDokumen.jenisSk !== 'SK Pengangkatan PPPK'
          ) {
            arr.push(optionPYB[6]);
          } else if (
            dataDokumen.jenis === 'SK TUGAS BELAJAR' ||
            (dataDokumen.jenis === 'SK PPPK' &&
              (dataDokumen.jenisSk === 'SK Pengangkatan Calon PPPK' ||
                dataDokumen.jenisSk === 'SK Pengangkatan PPPK'))
          ) {
            arr.push(katimjaHumanCapital);
          } else if (dataDokumen.jenis !== 'SK TUGAS BELAJAR') {
            arr.push(optionPYB[5]);
          }

          arr.push(optionPYB[3]);
          setDataDokumen({
            ...dataDokumen,
            displayApproval: arr,
            penanda: value,
          });
          break;

        case 2:
          arr = [];
          if (
            dataDokumen.jenisSk === 'SK Kenaikan Jabatan FT' ||
            dataDokumen.jenis === 'SK PEMBERHENTIAN' ||
            dataDokumen.jenis === 'SK MUTASI'
          ) {
            arr.push(optionPYB[4]);
          } else if (
            dataDokumen.jenisSk === 'SK Pengangkatan Calon PPPK' ||
            dataDokumen.jenisSk === 'SK Pengangkatan PPPK'
          ) {
            arr.push(katimjaHumanCapital);
          } else {
            arr.push(optionPYB[5]);
          }

          setDataDokumen({
            ...dataDokumen,
            displayApproval: arr,
            penanda: value,
          });
          break;

        default:
          break;
      }
    }
  };

  const renderBreadcrumb = () => {
    return (
      <Breadcrumbs aria-label='breadcrumb'>
        <Typography
          sx={{
            cursor: 'pointer',
            fontWeight: pathname === '/apps/dokumen-sk' ? 'bold' : '500',
          }}
          color={'primary.default'}
          variant='h3'
          onClick={() => {
            navigation(`/apps/dokumen-sk`);
          }}
        >
          Dokumen Sk
        </Typography>

        {pathname === `/apps/dokumen-sk/tambah-dokumen/${tipeDokumen}` ? (
          <Typography
            color={'primary.default'}
            sx={{cursor: 'pointer'}}
            variant='h3'
            fontWeight={'bold'}
          >
            Tambah
          </Typography>
        ) : pathname ===
            `/apps/dokumen-sk/tambah-dokumen/${tipeDokumen}/${id}` &&
          id !== undefined ? (
          <Typography
            color={'primary.default'}
            sx={{cursor: 'pointer'}}
            variant='h3'
            fontWeight={'bold'}
          >
            Ubah Draft
          </Typography>
        ) : pathname === '/apps/dokumen-sk/tanda-tangan' ? (
          <Typography
            color={'primary.default'}
            sx={{cursor: 'pointer'}}
            variant='h3'
            fontWeight={'bold'}
          >
            Tanda Tangan
          </Typography>
        ) : id !== undefined &&
          pathname === `/apps/dokumen-sk/detail/${tipeDokumen}/${id}` ? (
          <Typography
            color={'primary.default'}
            sx={{cursor: 'pointer'}}
            variant='h3'
            fontWeight={'bold'}
          >
            Detail
          </Typography>
        ) : null}
      </Breadcrumbs>
    );
  };

  const isRevision = id !== undefined && detail?.state === 'draft';

  useEffect(() => {
    if (optionPYB.length > 0 && pilihanPenanda.length === 0) {
      let arr = [];
      arr.push(optionPYB[0]);
      if (dataDokumen.jenis !== 'SK DISIPLIN') {
        arr.push(optionPYB[2]);
        if (dataDokumen.jenis !== 'SK TUGAS BELAJAR') {
          arr.push(optionPYB[3]);
        }
      }

      setpilihanPenanda(arr);
    }
    if (dataDokumen.penanda !== '')
      setTimeout(() => {
        handleOnChangePenanda('penanda', dataDokumen.penanda);
      }, 500);
  }, [optionPYB, dataDokumen.penanda, pilihanPenanda]);

  useEffect(() => {
    if (attachment.length !== 0 && !isUploadDokumen) {
      openPDF(attachment[0].file);
      let labelSign =
        window.location.protocol +
        '//' +
        window.location.host +
        '/assets/images/Tandatangan.png';
      getLabelSign(labelSign);
    }
  }, [attachment]);

  useEffect(() => {
    if (dataDokumen.jenis !== '') {
      const selectedCategory = dataDokumen.jenis;
      const filtered = optionJenisSk.filter(
        (option) =>
          option.category === selectedCategory || selectedCategory === '',
      );
      setFilteredJenisSkOption(filtered);

      let arr = [];
      if (optionPYB.length > 0) {
        arr.push(optionPYB[0]);
        if (dataDokumen.jenis !== 'SK DISIPLIN') {
          arr.push(optionPYB[2]);
          if (dataDokumen.jenis !== 'SK TUGAS BELAJAR') {
            arr.push(optionPYB[3]);
          }
        } else {
          setDataDokumen((prev) => ({
            ...prev,
            penanda: arr[0].origin.nik,
          }));
        }
        setpilihanPenanda(arr);
      }
    }
  }, [dataDokumen.jenis]);

  useEffect(() => {
    if (tipeDokumen === 'sdmao') dispatch(onGetDokumenSKPYB());
    else getDefaultPPID();
  }, []);

  useEffect(() => {
    if (optionPYBPPID && !id && tipeDokumen === 'ppid') {
      let code = [];
      let display = [];
      let payload = [];

      optionPYBPPID.forEach((item) => {
        const nip = item.origin.nik;
        const nama = item.name;
        const tmp = {
          id: item.objidposisi,
          code: item.origin.nik,
          text: item.name,
          nip: item.origin.nik,
        };
        payload.push(tmp);
        code.push(nip);
        display.push({nama});
      });

      setDataDokumen({
        ...dataDokumen,
        displayPPID: display,
        ppidCode: code,
        pilihanPPID: [...payload],
      });
    }
  }, [optionPYBPPID]);

  useEffect(() => {
    if (!stateAddress.isClose && !stateAddress.show) {
      const processPayload = (payload, type) => {
        let code = [];
        let display = [];
        let nipList = [];

        payload.forEach((item) => {
          const nip =
            item.nip ||
            item.oriItem?.nip ||
            item.oriItem?.officer?.official?.split('/')[1];
          const nama =
            item.oriItem?.officer?.official?.split('/')[0] ||
            item.text.split('/')[0];
          const title = item.oriItem?.title || item.title || '';

          code.push(nip);
          display.push({title, nama});
        });

        return {code, display, nipList};
      };

      const {judul} = config;
      const {payload} = stateAddress;

      if (judul === 'Penerima') {
        const {code, display} = processPayload(payload, 'Penerima');
        setDataDokumen({
          ...dataDokumen,
          displayPenerima: display,
          penerimaCode: code,
          pilihanPenerima: [...payload],
        });
      } else if (judul === 'Tembusan') {
        const {code, display} = processPayload(payload, 'Tembusan');

        setDataDokumen({
          ...dataDokumen,
          displayTembusan: display,
          tembusanCode: code,
          pilihanTembusan: [...payload],
        });
      } else if (judul === 'Penanda') {
        const {code, display} = processPayload(payload, 'Penanda');

        setDataDokumen({
          ...dataDokumen,
          displayPPID: display,
          ppidCode: code,
          pilihanPPID: [...payload],
        });
      }
    }
  }, [stateAddress, config]);

  useEffect(() => {
    if (pathname === '/apps/dokumen-lain/tambah-dokumen') {
      handleResetDocument();
    }
    if (tipeDokumen === 'sdmao') dispatch(onGetDokumenSKPYB());
    else getDefaultPPID();
  }, [pathname]);

  useEffect(() => {
    if (
      id !== undefined &&
      pathname === `/apps/dokumen-sk/tambah-dokumen/${tipeDokumen}/${id}`
    ) {
      setUploadedFiles(null);
      dispatch(onDeleteAttachmentDigisign());
      dispatch(onGetDetailDraftDigisign(id));
    }
  }, [id]);

  useEffect(() => {
    if (
      detail !== null &&
      id !== undefined &&
      pathname === `/apps/dokumen-sk/tambah-dokumen/${tipeDokumen}/${id}`
    ) {
      const dataDisplayPenerima = [];
      const dataCodePenerima = [];
      const dataPilihanPenerima = [];
      const dataDisplayPenanda = [];
      const dataCodePenanda = [];
      const dataPilihanPenanda = [];

      detail.receivers?.map((item, index) => {
        dataDisplayPenerima.push(
          item.is_title ? item.display_title : item.nama,
        );
        dataCodePenerima.push(item.is_title ? item.objidposisi : item.nip);
        dataPilihanPenerima.push({
          id: item.is_title ? item.objidposisi : item.nip,
          code: item.is_title ? item.objidposisi : item.nip,
          text: item.is_title ? item.display_title : item.nama,
          nip: item.is_title ? item.officer.nip : item.nip,
          title: item.is_title ? item.display_title : item.nama,
          name: item.is_title ? item.display_title : item.nama,
        });
      });

      if (tipeDokumen === 'ppid' || tipeDokumen === 'dirjend') {
        detail.approvers.shift();
        detail.approvers?.map((item, index) => {
          dataDisplayPenanda.push({
            title: item.is_title ? item.display_title : item.nama,
            nama: item.is_title ? item.display_title : item.nama,
          });
          dataCodePenanda.push(item.is_title ? item.objidposisi : item.nip);
          dataPilihanPenanda.push({
            id: item.is_title ? item.objidposisi : item.nip,
            code: item.is_title ? item.objidposisi : item.nip,
            text: item.is_title ? item.display_title : item.nama,
            nip: item.is_title ? item.officer.nip : item.nip,
            title: item.is_title ? item.display_title : item.nama,
            name: item.is_title ? item.display_title : item.nama,
          });
        });
      }

      const dataDisplayTembusan = [];
      const dataCodeTembusan = [];
      const dataPilihanTembusan = [];

      detail.tembusans?.map((item, index) => {
        dataDisplayTembusan.push(
          item.is_title ? item.display_title : item.nama,
        );
        dataCodeTembusan.push(item.is_title ? item.objidposisi : item.nip);
        dataPilihanTembusan.push({
          id: item.is_title ? item.objidposisi : item.nip,
          code: item.is_title ? item.objidposisi : item.nip,
          text: item.is_title ? item.display_title : item.nama,
          nip: item.is_title ? item.officer.nip : item.nip,
          title: item.is_title ? item.display_title : item.nama,
          name: item.is_title ? item.display_title : item.nama,
        });
      });

      let pop = [...detail.approvers].pop();
      setDataDokumen({
        ...dataDokumen,
        judul: detail.subject,
        noSertif: detail.extra_attributes?.noDokumen,
        jenis: detail.extra_attributes?.tipeDokumen?.toUpperCase(),
        jenisSk: detail.extra_attributes?.jenisDokumen,
        tglSurat: moment(detail.extra_attributes?.tanggalDokumen).format(
          'YYYY-MM-DD',
        ),
        penanda: pop.nip,
        displayPenerima: dataPilihanPenerima,
        penerimaCode: dataCodePenerima,
        tembusanCode: dataCodeTembusan,
        displayTembusan: dataPilihanTembusan,
        pilihanTembusan: dataPilihanTembusan,
        pilihanPenerima: dataPilihanPenerima,
        displayPPID: dataDisplayPenanda,
        pilihanPPID: dataPilihanPenanda,
        ppidCode: dataCodePenanda,
        keterangan: detail.extra_attributes?.keterangan,
        formError: {
          judul: '',
          errorJudul: false,
          noSertif: '',
          errorNoSertif: false,
          jenis: '',
          errorJenis: false,
          penanda: '',
          errorPenanda: false,
          attachment: '',
          errorAttachment: false,
          keterangan: '',
          errorKeterangan: false,
          penerima: '',
          errorPenerima: false,
        },
      });
    }
  }, [detail]);

  return (
    <>
      <AppInfoView />

      <Stack direction='column' spacing={2} minHeight={'100vh !important'}>
        {renderBreadcrumb()}

        <Grid container>
          <Grid className='pe-3' item xs={12} md={isRevision ? 9 : 12}>
            <AppCard
              sxStyle={{
                backgroundColor: 'white !important',
                height: '100% !important',
              }}
            >
              <Stack
                sx={{
                  '& label.Mui-focused': {
                    color: COLORS.primary,
                  },
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: grey[500],
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: COLORS.primary,
                      color: COLORS.primary,
                    },
                  },
                }}
                spacing={2}
                height={'100% !important'}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Box>
                    <Tooltip title={'Kembali'} placement='top' arrow>
                      <IconButton onClick={handleCancelDocument}>
                        <ArrowBack />
                      </IconButton>
                    </Tooltip>
                  </Box>

                  <Stack direction='row' spacing={2}>
                    {detail?.logs?.length > 0 && (
                      <ButtonOutlined
                        variant='text'
                        startIcon={<Info />}
                        onClick={() => setOpenPetunjuk(true)}
                      >
                        Petunjuk
                      </ButtonOutlined>
                    )}
                    <ButtonOutlined
                      variant='outlined'
                      onClick={handleCancelDocument}
                    >
                      Batal
                    </ButtonOutlined>
                    <ButtonContained
                      variant='contained'
                      sx={{
                        '&:hover': {background: '#a58b67 !important'},
                        background: '#d2b48c !important',
                      }}
                      onClick={() => setModalConfSave(true)}
                    >
                      {id === undefined ? 'Simpan Draf' : 'Ubah Draf'}
                    </ButtonContained>
                    <ButtonContained
                      variant='contained'
                      onClick={() => setModalConfSubmit(true)}
                    >
                      Kirim
                    </ButtonContained>
                  </Stack>
                </Box>

                <Divider />

                <Grid container columnSpacing={4} rowGap={5}>
                  {tipeDokumen === 'sdmao' && (
                    <>
                      <Grid item xs={12} md={dataDokumen.jenis ? 6 : 12}>
                        <Stack spacing={1}>
                          <InputLabel htmlFor='jenis' sx={{fontWeight: 600}}>
                            Kategori SK<span style={{color: 'red'}}>*</span>
                          </InputLabel>
                          <FormControl sx={{m: 1, minWidth: 120}}>
                            <Select
                              fullWidth
                              name='jenis'
                              variant='outlined'
                              labelId='dropdown'
                              id='dropdown'
                              value={dataDokumen.jenis}
                              error={dataDokumen.formError.errorJenis}
                              onChange={(e) =>
                                handleInputDocument(
                                  e.target.name,
                                  e.target.value,
                                )
                              }
                            >
                              <MenuItem value={'SK JF'}>SK JF</MenuItem>
                              <MenuItem value={'SK MUTASI'}>SK Mutasi</MenuItem>
                              <MenuItem value={'SK PEMBERHENTIAN'}>
                                SK Pemberhentian
                              </MenuItem>
                              <MenuItem value={'SK PPPK'}>SK PPPK</MenuItem>
                              <MenuItem value={'SK DISIPLIN'}>
                                SK Disiplin
                              </MenuItem>
                              <MenuItem value={'SK TUGAS BELAJAR'}>
                                SK Tugas Belajar
                              </MenuItem>
                            </Select>
                          </FormControl>
                          {dataDokumen.formError.errorJenis ? (
                            <Typography variant='caption' color={red[500]}>
                              {dataDokumen.formError.jenis}
                            </Typography>
                          ) : null}
                        </Stack>
                      </Grid>

                      {dataDokumen.jenis ? (
                        <Grid item xs={12} md={6}>
                          <Stack spacing={1}>
                            <InputLabel
                              htmlFor='jenisSk'
                              sx={{fontWeight: 600}}
                            >
                              Jenis SK<span style={{color: 'red'}}>*</span>
                            </InputLabel>
                            <FormControl sx={{m: 1, minWidth: 120}}>
                              <Select
                                fullWidth
                                name='jenisSk'
                                variant='outlined'
                                labelId='dropdown'
                                id='dropdown'
                                value={dataDokumen.jenisSk}
                                error={dataDokumen.formError.errorJenis}
                                onChange={(e) =>
                                  handleInputDocument(
                                    e.target.name,
                                    e.target.value,
                                  )
                                }
                              >
                                {dataDokumen.jenis !== ''
                                  ? filteredJenisSkOption.map((x, index) => {
                                      return (
                                        <MenuItem key={index} value={x.value}>
                                          {x.label}
                                        </MenuItem>
                                      );
                                    })
                                  : ''}
                              </Select>
                            </FormControl>
                            {dataDokumen.formError.errorJenis ? (
                              <Typography variant='caption' color={red[500]}>
                                {dataDokumen.formError.jenis}
                              </Typography>
                            ) : null}
                          </Stack>
                        </Grid>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                  <Grid item xs={12} md={4}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor='judul' sx={{fontWeight: 600}}>
                        Judul SK<span style={{color: 'red'}}>*</span>
                      </InputLabel>
                      <TextField
                        fullWidth
                        name='judul'
                        placeholder='Masukan Judul SK'
                        variant='outlined'
                        value={dataDokumen.judul}
                        error={dataDokumen.formError.errorJudul}
                        onChange={(e) =>
                          handleInputDocument(e.target.name, e.target.value)
                        }
                      />
                      {dataDokumen.formError.errorJudul ? (
                        <Typography variant='caption' color={red[500]}>
                          {dataDokumen.formError.judul}
                        </Typography>
                      ) : null}
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor='noSertif' sx={{fontWeight: 600}}>
                        No SK<span style={{color: 'red'}}>*</span>
                      </InputLabel>
                      <TextField
                        fullWidth
                        name='noSertif'
                        placeholder='Masukan No SK'
                        variant='outlined'
                        value={dataDokumen.noSertif}
                        error={dataDokumen.formError.errorNoSertif}
                        onChange={(e) =>
                          handleInputDocument(e.target.name, e.target.value)
                        }
                      />
                      {dataDokumen.formError.errorNoSertif ? (
                        <Typography variant='caption' color={red[500]}>
                          {dataDokumen.formError.noSertif}
                        </Typography>
                      ) : null}
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor='tglSurat' sx={{fontWeight: 600}}>
                        Tanggal Surat<span style={{color: 'red'}}>*</span>
                      </InputLabel>
                      <TextField
                        fullWidth
                        type='date'
                        name='tglSurat'
                        placeholder='Masukan Tanggal Surat SK'
                        variant='outlined'
                        value={dataDokumen.tglSurat}
                        error={dataDokumen.formError.errorTglSurat}
                        onChange={(e) =>
                          handleInputDocument(e.target.name, e.target.value)
                        }
                      />
                      {dataDokumen.formError.errorTglSurat ? (
                        <Typography variant='caption' color={red[500]}>
                          {dataDokumen.formError.errorTglSurat}
                        </Typography>
                      ) : null}
                    </Stack>
                  </Grid>
                  {(tipeDokumen === 'ppid' || tipeDokumen === 'dirjend') && (
                    <>
                      <Grid item xs={12} md={12}>
                        <Stack spacing={1}>
                          <InputLabel
                            sx={{fontWeight: 600, cursor: 'pointer'}}
                            onClick={() => handleToggleAddressBook('Penanda')}
                          >
                            Penandatangan<span style={{color: 'red'}}>*</span>
                          </InputLabel>

                          <TextField
                            fullWidth
                            placeholder='Pilih dari Addressbook'
                            variant='outlined'
                            name='penanda'
                            error={dataDokumen.formError.penanda}
                            onClick={() => handleToggleAddressBook('Penanda')}
                          />
                          {dataDokumen.formError.errorPenanda ? (
                            <Typography variant='caption' color={red[500]}>
                              {dataDokumen.formError.penanda}
                            </Typography>
                          ) : null}

                          {dataDokumen.displayPPID && (
                            <AppList
                              data={dataDokumen.displayPPID.slice(0, 4)}
                              renderRow={(item, index) => (
                                <AddressBookItem
                                  item={item}
                                  onDeleteAddressBook={() =>
                                    onDeleteAddressBook(item, 'Penanda')
                                  }
                                  labelDelete='Hapus Penanda'
                                  index={index}
                                  jabatan={true}
                                />
                              )}
                            />
                          )}
                          {dataDokumen.displayPPID.length >= 5 ? (
                            <Stack direction='row' justifyContent={'flex-end'}>
                              <Typography
                                variant='body1'
                                color={COLORS.primary}
                                sx={{cursor: 'pointer'}}
                                onClick={() =>
                                  setOpenAddressbook({
                                    toggle: true,
                                    id: 'Penanda',
                                  })
                                }
                              >
                                Lihat Selengkapnya
                              </Typography>
                            </Stack>
                          ) : null}
                        </Stack>
                      </Grid>
                    </>
                  )}

                  {tipeDokumen === 'sdmao' && (
                    <Grid item xs={12} md={12}>
                      <Grid item xs={12} md={12}>
                        <Stack spacing={1}>
                          <InputLabel sx={{fontWeight: 600, cursor: 'pointer'}}>
                            Penandatangan<span style={{color: 'red'}}>*</span>
                          </InputLabel>

                          <FormControl sx={{m: 1, minWidth: 120}}>
                            <Select
                              name='penanda'
                              variant='outlined'
                              labelId='dropdown'
                              id='penanda'
                              fullWidth
                              error={dataDokumen.formError.errorPenanda}
                              value={dataDokumen.penanda}
                              onChange={(e) =>
                                handleOnChangePenanda(
                                  e.target.name,
                                  e.target.value,
                                )
                              }
                            >
                              {pilihanPenanda.map((x, index) => {
                                return (
                                  <MenuItem key={index} value={x.origin.nik}>
                                    {x.name}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                          {dataDokumen.formError.errorPenanda ? (
                            <Typography variant='caption' color={red[500]}>
                              {dataDokumen.formError.penanda}
                            </Typography>
                          ) : null}
                        </Stack>
                      </Grid>
                      <Stack spacing={1}>
                        <Box className='p-3'>
                          <InputLabel sx={{fontWeight: 600, cursor: 'pointer'}}>
                            Approval<span style={{color: 'red'}}>*</span>
                          </InputLabel>
                          <AppList
                            data={dataDokumen.displayApproval}
                            renderRow={(item, index) => (
                              <AddressBookItem item={item.name} index={index} />
                            )}
                          />
                        </Box>

                        {dataDokumen?.displayApproval?.length >= 5 ? (
                          <Stack direction='row' justifyContent={'flex-end'}>
                            <Typography
                              variant='body1'
                              color={COLORS.primary}
                              sx={{cursor: 'pointer'}}
                              onClick={() =>
                                setOpenAddressbook({
                                  toggle: true,
                                  id: 'Approval',
                                })
                              }
                            >
                              Lihat Selengkapnya
                            </Typography>
                          </Stack>
                        ) : null}
                        {dataDokumen.formError.errorApproval ? (
                          <Typography variant='caption' color={red[500]}>
                            {dataDokumen.formError.approval}
                          </Typography>
                        ) : null}
                      </Stack>
                    </Grid>
                  )}

                  <Grid item xs={12} md={12}>
                    <Stack spacing={1}>
                      <InputLabel
                        onClick={() => handleToggleAddressBook('Penerima')}
                        sx={{fontWeight: 600, cursor: 'pointer'}}
                      >
                        Penerima<span style={{color: 'red'}}>*</span>
                      </InputLabel>

                      <TextField
                        fullWidth
                        placeholder='Pilih dari Addressbook'
                        variant='outlined'
                        name='penerima'
                        error={dataDokumen.formError.errorPenerima}
                        onClick={() => handleToggleAddressBook('Penerima')}
                      />

                      <AppList
                        data={dataDokumen.displayPenerima.slice(0, 4)}
                        renderRow={(item, index) => (
                          <AddressBookItem
                            item={item}
                            onDeleteAddressBook={() =>
                              onDeleteAddressBook(item, 'Penerima')
                            }
                            labelDelete='Hapus Penerima'
                            index={index}
                            jabatan={true}
                          />
                        )}
                      />
                      {dataDokumen.displayPenerima.length >= 5 ? (
                        <Stack direction='row' justifyContent={'flex-end'}>
                          <Typography
                            variant='body1'
                            color={COLORS.primary}
                            sx={{cursor: 'pointer'}}
                            onClick={() =>
                              setOpenAddressbook({
                                toggle: true,
                                id: 'Penerima',
                              })
                            }
                          >
                            Lihat Selengkapnya
                          </Typography>
                        </Stack>
                      ) : null}
                      {dataDokumen.formError.errorPenerima ? (
                        <Typography variant='caption' color={red[500]}>
                          {dataDokumen.formError.penerima}
                        </Typography>
                      ) : null}
                    </Stack>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Stack spacing={1}>
                      <InputLabel
                        onClick={() => handleToggleAddressBook('Tembusan')}
                        sx={{fontWeight: 600, cursor: 'pointer'}}
                      >
                        Tembusan
                      </InputLabel>

                      <TextField
                        fullWidth
                        placeholder='Pilih dari Addressbook'
                        variant='outlined'
                        error={dataDokumen.formError.errorTembusan}
                        onClick={() => handleToggleAddressBook('Tembusan')}
                      />

                      <AppList
                        data={dataDokumen.displayTembusan.slice(0, 4)}
                        renderRow={(item, index) => (
                          <AddressBookItem
                            item={item}
                            onDeleteAddressBook={() =>
                              onDeleteAddressBook(item, 'Tembusan')
                            }
                            labelDelete='Hapus Tembusan'
                            index={index}
                            jabatan={true}
                          />
                        )}
                      />
                      {dataDokumen.displayTembusan.length >= 5 ? (
                        <Stack direction='row' justifyContent={'flex-end'}>
                          <Typography
                            variant='body1'
                            color={COLORS.primary}
                            sx={{cursor: 'pointer'}}
                            onClick={() =>
                              setOpenAddressbook({
                                toggle: true,
                                id: 'Tembusan',
                              })
                            }
                          >
                            Lihat Selengkapnya
                          </Typography>
                        </Stack>
                      ) : null}
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor='keterangan' sx={{fontWeight: 600}}>
                        Keterangan
                      </InputLabel>
                      <TextField
                        fullWidth
                        name='keterangan'
                        multiline
                        minRows={5}
                        placeholder='Masukan Keterangan'
                        variant='outlined'
                        value={dataDokumen.keterangan}
                        error={dataDokumen.formError.errorKeterangan}
                        onChange={(e) =>
                          handleInputDocument(e.target.name, e.target.value)
                        }
                      />
                      {dataDokumen.formError.errorKeterangan ? (
                        <Typography variant='caption' color={red[500]}>
                          {dataDokumen.formError.keterangan}
                        </Typography>
                      ) : null}
                    </Stack>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor='lampiran' sx={{fontWeight: 600}}>
                        Lampiran<span style={{color: 'red'}}>*</span>
                      </InputLabel>
                      <UploadModern
                        uploadText='Seret dan jatuhkan unggah file sertifikat dalam format PDF file di sini, atau klik untuk memilih file'
                        getRootProps={getRootProps({className: 'dropzone'})}
                        getInputProps={getInputProps()}
                      />
                      {attachment.length !== 0 ? (
                        <FileRow
                          key={uploadedFiles.name}
                          file={uploadedFiles}
                          onDeleteUploadFile={onDeleteUploadFile}
                        />
                      ) : null}
                    </Stack>

                    {attachment.length !== 0 && (
                      <Stack spacing={4} height={'100vh'}>
                        <Stack id={'wrapperIframe'} flex={1}>
                          <iframe
                            src='/assets/latest-pdfjs-dist/web/viewer.html'
                            id='iframeDokLain'
                            style={{height: '100%', border: 0}}
                          />
                        </Stack>
                        <Stack direction={'row'} justifyContent={'end'}>
                          <Tooltip
                            arrow
                            placement='bottom'
                            title={'Upload dokumen PDF yang sudah ada label'}
                          >
                            <ButtonContained
                              variant='contained'
                              onClick={handleUploadDokumen}
                            >
                              Upload Dokumen
                            </ButtonContained>
                          </Tooltip>
                        </Stack>
                      </Stack>
                    )}

                    {dataDokumen.formError.errorAttachment ? (
                      <Typography variant='caption' color={red[500]}>
                        {dataDokumen.formError.attachment}
                      </Typography>
                    ) : null}
                  </Grid>
                </Grid>
              </Stack>
            </AppCard>
          </Grid>

          {isRevision && (
            <Grid item xs={12} md={3}>
              <AppCard
                sxStyle={{
                  backgroundColor: 'white !important',
                  position: 'sticky',
                  top: 0,
                  height: '100vh',
                }}
                contentStyle={{padding: '0 !important'}}
              >
                <Stack spacing={4} height={'100%'} paddingY={'16px'}>
                  <Stack paddingX={'24px'}>
                    <Typography
                      variant='h3'
                      fontWeight={'bold'}
                      color={'primary.default'}
                      component='div'
                      textTransform={'capitalize'}
                    >
                      Riwayat Aktivitas
                    </Typography>
                  </Stack>

                  <Stack height={'100%'} position={'relative'}>
                    <Stack position={'absolute'} width={'100%'} height={'100%'}>
                      <AppScrollbar>
                        <Stack paddingX={'24px'}>
                          <LogHistory data={detail?.logs} />
                        </Stack>
                      </AppScrollbar>
                    </Stack>
                  </Stack>
                </Stack>
              </AppCard>
            </Grid>
          )}
        </Grid>
      </Stack>

      <AppConfirmDialog
        open={modalConfSubmit}
        onDeny={() => {
          setModalConfSubmit(false);
        }}
        onConfirm={() => {
          setModalConfSubmit(false);
          handleSubmitDokumen('submit');
        }}
        title={'Apakah anda yakin akan submit dokumen sk ini' + '?'}
        dialogTitle={'Submit SK'}
      />

      <AppConfirmDialog
        open={modalConfSave}
        onDeny={() => {
          setModalConfSave(false);
        }}
        onConfirm={() => {
          setModalConfSave(false);
          handleSubmitDokumen('draft');
        }}
        title={
          'Apakah anda yakin akan menyimpan dokumen sk ini sebagai draft' + '?'
        }
        dialogTitle={'Save SK as Draft'}
      />

      <Addressbook
        stateAddress={stateAddress}
        toggleHide={toggleHide}
        setPayloadOnHide={setPayloadOnHide}
        config={config}
      />
      <PetunjukDialog
        open={openPetunjuk}
        detail={detail}
        handleClose={() => setOpenPetunjuk(false)}
        action='tambah'
      />
      <AddressBookWrapper
        open={openAddressbook.toggle}
        handleClose={() => setOpenAddressbook({toggle: false, id: ''})}
        data={
          openAddressbook.id === 'Penerima'
            ? dataDokumen.displayPenerima
            : dataDokumen.displayTembusan
        }
        onDeleteAddressBook={onDeleteAddressBook}
        multiple={true}
        id={openAddressbook.id}
        jabatan={true}
        title='List Penandatangan'
        placeholderSearch='Cari Penandatangan'
      />
    </>
  );
};

TambahDokumen.propTypes = {
  tipeDokumen: PropTypes.string,
};

export default TambahDokumen;
